"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableReference = exports.EditableBimLocations = exports.EditableEvaluation = exports.EditableLinks = exports.EditableCausality = exports.EditableRelation = exports.EditableBoxes = exports.EditableUserSuggest = exports.noOwner = exports.EditableDate = exports.EditableAutoSuggest = exports.EditableToggle = exports.ButtonGroupCell = exports.EditableSelect = exports.EditableTitle = exports.EditableMeasurement = exports.EditableMultiSelect = exports.EditableNumber = exports.EditableFile = exports.EditableText = exports.IdField = exports.EditableCell = exports.dispatchEditableCell = exports.BaseEditableCell = void 0;
var React = require("react");
var columns_1 = require("./columns");
var moment = require("moment");
var tablecells_1 = require("./tablecells");
var inputComponents_1 = require("./inputComponents");
var generic_1 = require("../generic");
var config_1 = require("../../config");
var userSuggest_1 = require("../lib/userSuggest");
var App_1 = require("../../App");
var constants_1 = require("../../constants");
var combobox_1 = require("../lib/combobox");
var typestyle_1 = require("typestyle");
var api_1 = require("../../api");
var buttons_1 = require("../buttons");
var riskbimContext_1 = require("../../context/RiskBim/riskbimContext");
var datepicker_1 = require("../datepicker");
var BaseEditableCell = (function (_super) {
    __extends(BaseEditableCell, _super);
    function BaseEditableCell(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            editMode: false,
            field: props.field,
        };
        return _this;
    }
    BaseEditableCell.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (nextProps.field !== this.props.field) {
            this.setState({
                field: nextProps.field,
            });
        }
    };
    BaseEditableCell.prototype.onDataAccepted = function (newField) {
        this.setState({
            field: newField,
        });
        this.triggerEditMode();
        this.props.refetchTable && this.props.refetchTable();
    };
    BaseEditableCell.prototype.submitData = function (newField, value) {
        var _this = this;
        if (newField.display == this.state.field.display &&
            newField.data == this.state.field.data) {
            this.triggerEditMode.bind(this)();
            return;
        }
        var data = {};
        data["id"] = newField.id;
        data[newField.fieldName] = value;
        if (newField.fieldName == columns_1.RiskColumnIds.USERDEFINED) {
            data["user_field_id"] = newField.user_field_id;
        }
        if (this.props.performRowUpdate) {
            this.props.performRowUpdate(data).then(function () {
                _this.onDataAccepted(newField);
            }, function (error) {
                api_1.api.apiErrorHandler(error, null, null);
                _this.triggerEditMode();
            });
        }
        else {
            console.warn("performRowUpdate is not defined");
        }
    };
    BaseEditableCell.prototype.onClick = function (e) {
        if (!this.state.editMode)
            this.triggerEditMode(e);
    };
    BaseEditableCell.prototype.triggerEditMode = function (e) {
        if (this.props.column.editable && !this.props.inBulkEditMode)
            this.setState(function (newState) {
                return {
                    editMode: !newState.editMode,
                };
            });
        else if (this.props.column.show_url && this.props.onClickLink) {
            this.props.onClickLink(e);
        }
    };
    BaseEditableCell.prototype.onClickUrl = function (e) {
        e.stopPropagation();
        if (this.props.onClickLink)
            this.props.onClickLink(e);
    };
    BaseEditableCell.prototype.getCellClasses = function () {
        var editable = this.props.column.editable
            ? "EditableList__Field--editable"
            : "";
        var singleEdit = this.state.editMode
            ? "EditableList__Field--editing"
            : editable;
        var bulkOrSingle = this.props.inBulkEditMode
            ? "EditableList__Field--editable-during-bulk"
            : singleEdit;
        return (0, typestyle_1.classes)(this.props.column.get_field_class(), bulkOrSingle);
    };
    BaseEditableCell.prototype.getContentClasses = function () {
        return "EditableList__FieldContent";
    };
    BaseEditableCell.prototype.renderField = function () {
        var props = this.props;
        return (React.createElement("td", { className: this.getCellClasses(), onClick: this.onClick.bind(this) },
            React.createElement("div", { className: this.getContentClasses() },
                props.column.show_url ? (React.createElement("a", { href: props.url, onClick: this.onClickUrl.bind(this) }, this.state.field.get_display())) : (this.state.field.get_display()),
                React.createElement("div", { className: "EditableList__pencil" },
                    React.createElement(generic_1.Icon, { name: generic_1.Icons.edit })))));
    };
    BaseEditableCell.prototype.renderInput = function () {
        this.triggerEditMode();
        return this.renderField();
    };
    BaseEditableCell.prototype.render = function () {
        if (this.state.editMode) {
            return this.renderInput();
        }
        else {
            return this.renderField();
        }
    };
    return BaseEditableCell;
}(React.Component));
exports.BaseEditableCell = BaseEditableCell;
function dispatchEditableCell(props) {
    var column = props.column;
    if (column instanceof columns_1.FileColumn) {
        return (React.createElement(EditableFile, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
    }
    if (column instanceof columns_1.TextColumn) {
        switch (props.field.fieldName) {
            case "title":
                return (React.createElement(EditableTitle, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
            default:
                return (React.createElement(EditableText, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
        }
    }
    else if (column instanceof columns_1.NumberColumn) {
        return (React.createElement(EditableNumber, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
    }
    else if (column instanceof columns_1.MultiSelectColumn) {
        return (React.createElement(EditableMultiSelect, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
    }
    else if (column instanceof columns_1.UserColumn)
        return (React.createElement(EditableUserSuggest, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
    else if (column instanceof columns_1.IdColumn)
        return (React.createElement(IdField, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
    else if (column instanceof columns_1.SelectColumn)
        return (React.createElement(EditableSelect, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
    else if (column instanceof columns_1.ButtonGroupColumn)
        return (React.createElement(ButtonGroupCell, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
    else if (column instanceof columns_1.AutoSuggestColumn)
        return (React.createElement(EditableAutoSuggest, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
    else if (column instanceof columns_1.DateColumn)
        return (React.createElement(EditableDate, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
    else if (column instanceof columns_1.EvaluationColumn)
        return (React.createElement(EditableEvaluation, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
    else if (column instanceof columns_1.BimLocationsColumn)
        return React.createElement(EditableBimLocations, __assign({}, props));
    else if (column instanceof columns_1.LinksColumn) {
        var relProps = props;
        return (React.createElement(EditableLinks, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable, fetchSearchResults: relProps.fetchSearchResults, fetchRowItems: relProps.fetchRowItems, edit: relProps.edit, attach: relProps.attach, detach: relProps.detach, onRelationLinkClick: relProps.onRelationLinkClick }));
    }
    else if (column instanceof columns_1.CausalityColumn) {
        var relProps = props;
        return (React.createElement(EditableCausality, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable, fetchSearchResults: relProps.fetchSearchResults, fetchRowItems: relProps.fetchRowItems, edit: relProps.edit, attach: relProps.attach, detach: relProps.detach }));
    }
    else if (column instanceof columns_1.CheckboxesColumn) {
        var removeField = null;
        if (props.field.fieldName == "tags") {
            removeField = new tablecells_1.TableCell(props.field.id, {}, "", "remove_tags");
        }
        else if (props.field.fieldName == "groups") {
            removeField = new tablecells_1.TableCell(props.field.id, {}, "", "remove_groups");
        }
        return (React.createElement(EditableBoxes, { field: props.field, removeField: removeField, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
    }
    else if (column instanceof columns_1.MeasurementColumn) {
        var column_field_name = null;
        if (props.field.fieldName == "control_cost") {
            column_field_name = "control_cost_target";
        }
        return (React.createElement(EditableMeasurement, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable, column_field_name: column_field_name }));
    }
    else if (column instanceof columns_1.ReferenceColumn) {
        return React.createElement(EditableReference, __assign({}, props));
    }
    else if (column instanceof columns_1.BooleanColumn) {
        return React.createElement(EditableToggle, __assign({}, props));
    }
    else
        return (React.createElement(EditableCell, { field: props.field, column: props.column, url: props.url, onClickLink: props.onClickLink, inBulkEditMode: props.inBulkEditMode, performRowUpdate: props.performRowUpdate, refetchTable: props.refetchTable }));
}
exports.dispatchEditableCell = dispatchEditableCell;
var EditableCell = (function (_super) {
    __extends(EditableCell, _super);
    function EditableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableCell.prototype.renderInput = function () {
        console.log("Error: Cannot make this cell editable");
        return _super.prototype.renderInput.call(this);
    };
    return EditableCell;
}(BaseEditableCell));
exports.EditableCell = EditableCell;
var IdField = (function (_super) {
    __extends(IdField, _super);
    function IdField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IdField.prototype.renderField = function () {
        var props = this.props;
        return (React.createElement("td", { className: props.column.get_field_class(), onClick: this.onClickUrl.bind(this) },
            React.createElement("div", { className: "EditableList__FieldContent" }, props.column.show_url ? (React.createElement("a", { href: props.url, onClick: this.onClickUrl.bind(this) }, this.state.field.get_display())) : (this.state.field.get_display()))));
    };
    return IdField;
}(BaseEditableCell));
exports.IdField = IdField;
var EditableText = (function (_super) {
    __extends(EditableText, _super);
    function EditableText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableText.prototype.onInputSubmit = function (name, value) {
        var newField = new tablecells_1.TextTableCell(this.state.field.id, value, value, this.state.field.fieldName, this.props.column.field_object_id);
        this.submitData(newField, value);
    };
    EditableText.prototype.renderInput = function () {
        return (React.createElement("td", { className: (0, typestyle_1.classes)(this.getCellClasses(), "EditableList__Field--no-pad") },
            React.createElement(inputComponents_1.InputText, { className: "EditableList__Field--TextInput", value: this.state.field.data, autofocus: true, disableScroll: true, onSubmit: this.onInputSubmit.bind(this) })));
    };
    return EditableText;
}(BaseEditableCell));
exports.EditableText = EditableText;
var EditableFile = (function (_super) {
    __extends(EditableFile, _super);
    function EditableFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableFile.prototype.onInputSubmit = function (name, value) {
        var newField = new tablecells_1.FileContentCell(this.state.field.id, new tablecells_1.TableCellDataFile(value, this.state.field.data.url), value, this.state.field.fieldName, this.props.column.field_object_id);
        this.submitData(newField, value);
    };
    EditableFile.prototype.submitData = function (newField, value) {
        if (newField.data.name == this.state.field.data.name) {
            this.triggerEditMode.bind(this)();
            return;
        }
        _super.prototype.submitData.call(this, newField, value);
    };
    EditableFile.prototype.changeFile = function (value) {
        this.setState(function (state) {
            state.field.data.content = value;
            return state;
        });
    };
    EditableFile.prototype.changeFileName = function (value) {
        this.setState(function (state) {
            state.field.data.file_name = value;
            return state;
        });
    };
    EditableFile.prototype.renderInput = function () {
        var _this = this;
        var field_name = this.state.field.fieldName;
        var file_name = this.state.field.data.file_name || this.state.field.data.name;
        return (React.createElement("td", { className: (0, typestyle_1.classes)(this.getCellClasses(), "EditableList__Field--no-pad") },
            React.createElement("div", { className: "form-group row no-gutters" },
                React.createElement("div", { className: "col" },
                    React.createElement("input", { className: "form-control EditableList__Field--TextInput", value: file_name, autoFocus: true, onChange: function (e) { return _this.changeFileName.bind(_this)(e.target.value); } })),
                React.createElement("div", { className: "col-sm-2" },
                    React.createElement(buttons_1.Button, { type: "button", noMargin: true, onClick: function () {
                            _this.onInputSubmit.bind(_this)(field_name, file_name);
                        } },
                        React.createElement("i", { className: "fas fa-check" })),
                    React.createElement(buttons_1.Button, { style: buttons_1.ButtonStyles.CANCEL, type: "button", noMargin: true, onClick: function () {
                            _this.triggerEditMode.bind(_this)();
                        } },
                        React.createElement("i", { className: "fas fa-ban" })))),
            React.createElement("div", { className: "form-group" },
                React.createElement("input", { className: "form-control-file", name: field_name, type: "file", value: null, onChange: function (e) {
                        return _this.changeFile.bind(_this)(e.target.files[0]);
                    } }))));
    };
    EditableFile.prototype.renderField = function () {
        var props = this.props;
        return (React.createElement("td", { className: this.getCellClasses(), onClick: this.onClick.bind(this) },
            React.createElement("div", { className: this.getContentClasses() },
                React.createElement("a", { href: this.state.field.data.url, target: "_blank", onClick: this.onClickUrl.bind(this) }, this.state.field.get_display()),
                React.createElement("div", { className: "EditableList__pencil" },
                    React.createElement(generic_1.Icon, { name: generic_1.Icons.edit })))));
    };
    return EditableFile;
}(BaseEditableCell));
exports.EditableFile = EditableFile;
var EditableNumber = (function (_super) {
    __extends(EditableNumber, _super);
    function EditableNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableNumber.prototype.onInputSubmit = function (name, value) {
        var postedValue = isNaN(value) ? "" : value;
        var newField = new tablecells_1.NumberTableCell(this.state.field.id, value, postedValue.toString(), this.state.field.fieldName, this.props.column.field_object_id);
        this.submitData(newField, postedValue);
    };
    EditableNumber.prototype.renderInput = function () {
        return (React.createElement("td", { className: (0, typestyle_1.classes)(this.getCellClasses(), "EditableList__Field--no-pad") },
            React.createElement(inputComponents_1.InputInteger, { name: this.props.field.fieldName, value: this.state.field.data, autofocus: true, onSubmit: this.onInputSubmit.bind(this) })));
    };
    return EditableNumber;
}(BaseEditableCell));
exports.EditableNumber = EditableNumber;
var EditableMultiSelect = (function (_super) {
    __extends(EditableMultiSelect, _super);
    function EditableMultiSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableMultiSelect.prototype.onInputSubmit = function (name, values) {
        var newField = new tablecells_1.SelectionsCell(this.state.field.id, values, values.join(", "), this.state.field.fieldName, this.props.column.field_object_id);
        this.submitData(newField, values);
    };
    EditableMultiSelect.prototype.renderInput = function () {
        return (React.createElement("td", { className: (0, typestyle_1.classes)(this.getCellClasses(), "EditableList__Field--no-pad") },
            React.createElement(inputComponents_1.InputMultiSelect, { name: this.props.field.fieldName, values: this.state.field.data || [], choices: this.props.column.options, autofocus: true, onSubmit: this.onInputSubmit.bind(this) })));
    };
    return EditableMultiSelect;
}(BaseEditableCell));
exports.EditableMultiSelect = EditableMultiSelect;
var EditableMeasurement = (function (_super) {
    __extends(EditableMeasurement, _super);
    function EditableMeasurement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableMeasurement.prototype.onInputSubmit = function (value) {
        if (value === "")
            value = null;
        if (value !== null && !/^[\-+]?[\d]*[\.]?[\d]*$/.test(value)) {
            notification(gettext("Invalid type"), {
                type: "error",
            });
            this.triggerEditMode();
            return;
        }
        var validatedValue = parseFloat(value);
        if ((isNaN(validatedValue) ? null : validatedValue) ==
            this.state.field.data.value) {
            this.triggerEditMode();
            return;
        }
        var newField = new tablecells_1.MeasurementTableCell(this.state.field.id, new tablecells_1.TableCellDataMeasurement(validatedValue, this.state.field.data.unit), isNaN(validatedValue)
            ? ""
            : "".concat(validatedValue, " ").concat(this.state.field.data.unit), this.state.field.fieldName);
        this.submitData(newField, value);
    };
    EditableMeasurement.prototype.submitData = function (newField, value) {
        var _this = this;
        var data = {};
        data["id"] = newField.id;
        data[newField.fieldName] = value;
        if (this.props.column_field_name && this.props.column.field_object_id) {
            data[this.props.column_field_name] =
                this.props.column.field_object_id;
        }
        if (this.props.performRowUpdate) {
            this.props.performRowUpdate(data).then(function () {
                _this.onDataAccepted(newField);
            }, function () {
                _this.triggerEditMode();
            });
        }
        else {
            console.warn("performRowUpdate is not defined");
        }
    };
    EditableMeasurement.prototype.renderInput = function () {
        return (React.createElement("td", { className: (0, typestyle_1.classes)(this.getCellClasses()) },
            React.createElement(inputComponents_1.InputMeasurementCell, { unit: this.state.field.data.unit, value: this.state.field.data.value, autofocus: true, onSubmit: this.onInputSubmit.bind(this) })));
    };
    return EditableMeasurement;
}(BaseEditableCell));
exports.EditableMeasurement = EditableMeasurement;
var EditableTitle = (function (_super) {
    __extends(EditableTitle, _super);
    function EditableTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableTitle.prototype.renderInput = function () {
        return (React.createElement("td", { className: (0, typestyle_1.classes)(this.getCellClasses(), "EditableList__Field--no-pad") },
            React.createElement(inputComponents_1.InputText, { className: "EditableList__Field--TextInput", value: this.state.field.data, autofocus: true, disableScroll: true, maxLength: 150, onSubmit: this.onInputSubmit.bind(this) })));
    };
    return EditableTitle;
}(EditableText));
exports.EditableTitle = EditableTitle;
var EditableSelect = (function (_super) {
    __extends(EditableSelect, _super);
    function EditableSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableSelect.prototype.onSubmitChoice = function (display, value) {
        var newField = new tablecells_1.TextTableCell(this.state.field.id, value, display, this.state.field.fieldName, this.props.column.field_object_id);
        this.submitData(newField, value);
    };
    EditableSelect.prototype.onChangeHandler = function (event) {
        var selected = event.target.options[event.target.selectedIndex];
        this.onSubmitChoice(selected.innerHTML, selected.value);
    };
    EditableSelect.prototype.renderField = function () {
        return _super.prototype.renderField.call(this);
    };
    EditableSelect.prototype.renderInput = function () {
        var choices = this.props.column.options;
        var data = this.state.field.data;
        return (React.createElement("td", { className: this.getCellClasses() },
            React.createElement(generic_1.ChoiceSelect, { choices: choices, value: data !== null ? data.toString() : "", autofocus: true, onBlur: this.onChangeHandler.bind(this), onChange: this.onChangeHandler.bind(this) })));
    };
    return EditableSelect;
}(BaseEditableCell));
exports.EditableSelect = EditableSelect;
var ButtonGroupCell = (function (_super) {
    __extends(ButtonGroupCell, _super);
    function ButtonGroupCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonGroupCell.prototype.confirmedButtonClick = function (display, value) {
        var newField = new tablecells_1.TextTableCell(this.state.field.id, value, display, this.state.field.fieldName, this.props.column.field_object_id);
        this.submitData(newField, value);
    };
    ButtonGroupCell.prototype.buttonClick = function (e, value) {
        if (!this.state.editMode) {
            this.setState(__assign(__assign({}, this.state), { selected: value, editMode: true }));
        }
    };
    ButtonGroupCell.prototype.abort = function () {
        this.setState(__assign(__assign({}, this.state), { selected: undefined, editMode: false }));
    };
    ButtonGroupCell.prototype.renderInput = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement("td", { className: this.getCellClasses() },
            React.createElement("div", { className: (0, typestyle_1.classes)(this.getContentClasses(), "text-center") }, props.column.options
                .filter(function (choice) { return choice.value == _this.state.selected; })
                .map(function (choice) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("p", null, gettext("Please confirm action:")),
                    React.createElement(buttons_1.Button, { onClick: function (e) {
                            _this.confirmedButtonClick(choice.display_name, choice.value);
                        }, onBlur: _this.abort.bind(_this), focus: true, style: buttons_1.ButtonStyles.ALERT, className: "btn-sm" }, choice.display_name),
                    " "));
            }))));
    };
    ButtonGroupCell.prototype.renderField = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement("td", { className: this.getCellClasses() },
            React.createElement("div", { className: this.getContentClasses() }, props.column.options.map(function (choice) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(buttons_1.Button, { onClick: function (e) {
                            _this.buttonClick(e, choice.value);
                        }, style: buttons_1.ButtonStyles.PRIMARY, className: "btn-sm" }, choice.display_name),
                    " "));
            }))));
    };
    return ButtonGroupCell;
}(BaseEditableCell));
exports.ButtonGroupCell = ButtonGroupCell;
var EditableToggle = (function (_super) {
    __extends(EditableToggle, _super);
    function EditableToggle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableToggle.prototype.onChangeHandler = function (event) {
        var value = event.target.checked;
        var newField = new tablecells_1.BooleanTableCell(this.state.field.id, value, value.toString(), this.state.field.fieldName, this.props.column.field_object_id);
        this.submitData(newField, value);
    };
    EditableToggle.prototype.renderInput = function () {
        return (React.createElement("td", { className: this.getCellClasses() },
            React.createElement("div", { className: "custom-control custom-switch" },
                React.createElement("input", { type: "checkbox", checked: this.state.field.data, className: "custom-control-input", id: "show_active_inactive", onChange: this.onChangeHandler.bind(this), onBlur: this.onChangeHandler.bind(this) }),
                React.createElement("label", { className: "custom-control-label", htmlFor: "show_active_inactive" }))));
    };
    return EditableToggle;
}(BaseEditableCell));
exports.EditableToggle = EditableToggle;
var EditableAutoSuggest = (function (_super) {
    __extends(EditableAutoSuggest, _super);
    function EditableAutoSuggest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableAutoSuggest.prototype.onSubmitChoice = function (display, value) {
        var newField = new tablecells_1.TextTableCell(this.state.field.id, value, display, this.state.field.fieldName, this.props.column.field_object_id);
        this.submitData(newField, value);
    };
    EditableAutoSuggest.prototype.setValue = function (value) {
        if (value != null)
            this.onSubmitChoice(value, value);
    };
    EditableAutoSuggest.prototype.blur = function () {
        this.triggerEditMode();
    };
    EditableAutoSuggest.prototype.renderInput = function () {
        return (React.createElement("td", { className: this.getCellClasses() },
            React.createElement(combobox_1.ComboBox, { className: "form-control", options: (0, combobox_1.choices_to_suggestions)(this.props.column.options), value: this.state.field.data.toString(), onBlur: this.blur.bind(this), onChange: this.setValue.bind(this) })));
    };
    return EditableAutoSuggest;
}(BaseEditableCell));
exports.EditableAutoSuggest = EditableAutoSuggest;
var EditableDate = (function (_super) {
    __extends(EditableDate, _super);
    function EditableDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableDate.computeUrgency = function (dateRepr) {
        var date = moment(dateRepr);
        return constants_1.DeadlineUrgencyChoices.checkDeadline(date);
    };
    EditableDate.prototype.onChangeHandler = function (date) {
        var newDate = null;
        if (date !== null) {
            newDate = date.format(config_1.ISO_DATE_FORMAT);
        }
        var newField = new tablecells_1.DeadlineTableCell(this.state.field.id, new tablecells_1.TableCellDataDeadline(EditableDate.computeUrgency(newDate)), newDate, this.state.field.fieldName, this.props.column.field_object_id);
        this.submitData(newField, newDate);
    };
    EditableDate.prototype.renderInput = function () {
        var self = this;
        var date = null;
        if (moment(this.state.field.display).isValid())
            date = moment(this.state.field.display);
        return (React.createElement("td", { className: this.getCellClasses() },
            React.createElement(datepicker_1.default, { selected: date, onChange: this.onChangeHandler.bind(this), autofocus: true })));
    };
    return EditableDate;
}(BaseEditableCell));
exports.EditableDate = EditableDate;
exports.noOwner = {
    id: 0,
    full_name: get_term("No Owner"),
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    company: "",
    two_factor: false,
};
var EditableUserSuggest = (function (_super) {
    __extends(EditableUserSuggest, _super);
    function EditableUserSuggest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableUserSuggest.prototype.onUserChange = function (value) {
        if (value === null)
            return;
        var selected_id = Number(value) || null;
        var selected = App_1.store.users.getUserById(selected_id);
        var newDisplay = "";
        if (selected)
            newDisplay = selected.full_name;
        var newField = new tablecells_1.OwnerTableCell(this.state.field.id, new tablecells_1.TableCellDataOwner(selected_id), newDisplay, this.state.field.fieldName);
        this.submitData(newField, selected_id);
    };
    EditableUserSuggest.prototype.renderInput = function () {
        return (React.createElement("td", { className: this.getCellClasses() },
            React.createElement(userSuggest_1.UserSuggest, { objects: [exports.noOwner].concat(App_1.store.users.users.map(function (u) { return u; })), selected: this.state.field.data.user_id, onBlur: this.triggerEditMode.bind(this), autofocus: true, onChange: this.onUserChange.bind(this) })));
    };
    return EditableUserSuggest;
}(BaseEditableCell));
exports.EditableUserSuggest = EditableUserSuggest;
var EditableBoxes = (function (_super) {
    __extends(EditableBoxes, _super);
    function EditableBoxes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableBoxes.prototype.onSubmit = function () {
        var values = this.state.field.data.selected;
        if (values.sort().join(",") ==
            this.state.field.data.original.sort().join(",")) {
            this.triggerEditMode.bind(this)();
            return;
        }
        var names = this.props.column.options
            .filter(function (option) { return values.indexOf(option.value) > -1; })
            .map(function (option) { return option.display_name; });
        var newField = new tablecells_1.CheckboxesTableCell(this.state.field.id, new tablecells_1.TableCellDataChoices(values, this.state.field.data.useRadioButtons, this.state.field.data.addNoSelectionOption), names.join(", "), this.state.field.fieldName);
        this.submitData(newField, values);
    };
    EditableBoxes.prototype.submitData = function (newField, values) {
        var _this = this;
        var data = {};
        data["id"] = newField.id;
        data[newField.fieldName] = values;
        if (this.props.removeField) {
            data[this.props.removeField.fieldName] = this.props.column.options
                .filter(function (choice) { return values.indexOf(choice.value.toString()) == -1; })
                .map(function (choice) { return choice.value; });
        }
        if (this.props.performRowUpdate) {
            this.props.performRowUpdate(data).then(function () {
                _this.onDataAccepted(newField);
            }, function (error) {
                api_1.api.apiErrorHandler(error, null, null);
                _this.state.field.data.selected = _this.state.field.data.original.slice();
                _this.setState({ field: _this.state.field });
                _this.triggerEditMode();
            });
        }
        else {
            console.warn("performRowUpdate is not defined");
        }
    };
    EditableBoxes.prototype.onChangeBox = function (e) {
        var useRadioButtons = this.state.field.data.useRadioButtons;
        var value = e.currentTarget.value;
        var selectionIndex = this.state.field.data.selected.indexOf(value);
        if (e.target.checked && selectionIndex == -1) {
            if (useRadioButtons) {
                this.state.field.data.selected.splice(0, this.state.field.data.selected.length);
                if (value !== "0") {
                    this.state.field.data.selected.push(value);
                }
            }
            else {
                this.state.field.data.selected.push(value);
            }
        }
        else if (!e.target.checked) {
            this.state.field.data.selected.splice(selectionIndex, 1);
        }
        this.setState({
            field: this.state.field,
        });
    };
    EditableBoxes.prototype.renderInput = function () {
        var _this = this;
        var choices = this.props.column.options.map(function (opt) {
            return {
                value: opt.value,
                labelText: opt.display_name,
                checked: _this.state.field.data.selected.indexOf(opt.value.toString()) > -1,
                onChange: _this.onChangeBox.bind(_this),
            };
        });
        if (this.state.field.data.addNoSelectionOption) {
            choices.unshift({
                value: "0",
                labelText: gettext("No selection"),
                checked: this.state.field.data.selected.length === 0,
                onChange: this.onChangeBox.bind(this),
            });
        }
        return (React.createElement("td", { className: this.getCellClasses() },
            React.createElement(inputComponents_1.Checkbox3List, { checkboxes: choices, onSubmit: this.onSubmit.bind(this), autofocus: true, useRadioButtons: this.state.field.data.useRadioButtons })));
    };
    return EditableBoxes;
}(BaseEditableCell));
exports.EditableBoxes = EditableBoxes;
var EditableRelation = (function (_super) {
    __extends(EditableRelation, _super);
    function EditableRelation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableRelation.prototype.renewState = function () {
        this.setState({
            field: Object.create(this.state.field),
        });
    };
    EditableRelation.prototype.onBlur = function () {
        this.renewState();
        this.triggerEditMode();
    };
    EditableRelation.prototype.formatSearchData = function (text) {
        return { text: text };
    };
    EditableRelation.prototype.fetchSearchResults = function (text) {
        return this.props.fetchSearchResults(this.state.field.id, this.formatSearchData(text));
    };
    EditableRelation.prototype.handleAttach = function (value) {
        var _this = this;
        var id_ = Number(value);
        if (id_) {
            this.props.attach(id_, this.state.field.id).then(function () {
                _this.props
                    .fetchRowItems(_this.state.field.id)
                    .then(function (relations) {
                    _this.updateDataAfterAttach(relations);
                });
            });
        }
    };
    EditableRelation.prototype.handleDetach = function (obj) {
        var _this = this;
        this.props
            .detach(obj, this.state.field.id)
            .then(function (detached) {
            if (detached) {
                _this.props
                    .fetchRowItems(_this.state.field.id)
                    .then(function (relations) {
                    _this.updateDataAfterDetach(relations);
                });
            }
        });
    };
    EditableRelation.prototype.updateDataAfterAttach = function (newRowRelations) {
        this.renewState();
        notification(gettext("Successfully attached new relation"));
    };
    EditableRelation.prototype.updateDataAfterDetach = function (newRowRelations) {
        this.renewState();
        notification(gettext("Successfully removed relation"));
    };
    EditableRelation.prototype.renderInput = function () {
        return (React.createElement("td", { className: this.getCellClasses() },
            React.createElement(inputComponents_1.RelationInputCell, { rowItems: [], fetchSuggestions: this.fetchSearchResults.bind(this), onBlur: this.onBlur.bind(this), handleAttach: this.handleAttach.bind(this), handleDelete: this.handleDetach.bind(this), handleEdit: this.props.edit })));
    };
    return EditableRelation;
}(BaseEditableCell));
exports.EditableRelation = EditableRelation;
var EditableCausality = (function (_super) {
    __extends(EditableCausality, _super);
    function EditableCausality() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableCausality.prototype.formatSearchData = function (text) {
        return {
            text: text,
            is_cause: this.state.field.data.isCause,
        };
    };
    EditableCausality.prototype.updateDataAfterAttach = function (causalities) {
        var _this = this;
        this.state.field.data.causalities = causalities
            .filter(function (c) { return c.is_cause === _this.state.field.data.isCause; })
            .sort(function (a, b) { return a.number - b.number; });
        this.renewState();
        if (this.state.field.data.isCause) {
            notification(get_term("Cause successfully attached"));
        }
        else {
            notification(get_term("Effect successfully attached"));
        }
    };
    EditableCausality.prototype.updateDataAfterDetach = function (causalities) {
        var _this = this;
        this.state.field.data.causalities = causalities
            .filter(function (c) { return c.is_cause === _this.state.field.data.isCause; })
            .sort(function (a, b) { return a.status - b.status || a.number - b.number; });
        this.renewState();
        if (this.state.field.data.isCause) {
            notification(get_term("Cause successfully removed"));
        }
        else {
            notification(get_term("Effect successfully removed"));
        }
    };
    EditableCausality.prototype.renderInput = function () {
        return (React.createElement("td", { className: this.getCellClasses() },
            React.createElement(inputComponents_1.CausalityInputCell, { rowItems: this.state.field.data.causalities, groupByFunc: this.state.field.data.show_statuses.length > 1
                    ? function (c) { return c.status_display; }
                    : null, sortObjects: function (a, b) {
                    return a.status - b.status || a.number - b.number;
                }, maxTextLength: 100, fetchSuggestions: this.fetchSearchResults.bind(this), onBlur: this.onBlur.bind(this), handleAttach: this.handleAttach.bind(this), handleDelete: this.handleDetach.bind(this), handleEdit: this.props.edit })));
    };
    return EditableCausality;
}(EditableRelation));
exports.EditableCausality = EditableCausality;
var EditableLinks = (function (_super) {
    __extends(EditableLinks, _super);
    function EditableLinks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableLinks.prototype.applyClickLinkHandler = function (links) {
        var _this = this;
        links.forEach(function (link) { return (link.onClick = _this.props.onRelationLinkClick); });
        return links;
    };
    EditableLinks.prototype.renewState = function () {
        this.state.field.data.links = this.applyClickLinkHandler(this.state.field.data.links);
        this.setState({
            field: Object.create(this.state.field),
        });
    };
    EditableLinks.prototype.componentWillMount = function () {
        this.renewState();
    };
    EditableLinks.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (this.props.field !== nextProps.field) {
            this.state.field.data.links = this.applyClickLinkHandler(nextProps.field.data.links);
            this.setState({
                field: Object.create(this.state.field),
            });
        }
        _super.prototype.componentWillReceiveProps.call(this, nextProps, nextContext);
    };
    EditableLinks.prototype.updateDataAfterAttach = function (links) {
        this.state.field.data.links = links;
        this.renewState();
        notification(gettext("Successfully attached"));
    };
    EditableLinks.prototype.updateDataAfterDetach = function (links) {
        this.state.field.data.links = links;
        this.renewState();
        notification(gettext("Successfully removed"));
    };
    EditableLinks.prototype.renderInput = function () {
        return (React.createElement("td", { className: this.getCellClasses() },
            React.createElement(inputComponents_1.LinkInputCell, { showTitles: this.state.field.data.show_titles, rowItems: this.state.field.data.links, fetchSuggestions: this.fetchSearchResults.bind(this), onBlur: this.onBlur.bind(this), handleAttach: this.handleAttach.bind(this), handleDelete: this.handleDetach.bind(this), handleEdit: this.props.edit })));
    };
    return EditableLinks;
}(EditableRelation));
exports.EditableLinks = EditableLinks;
var EditableEvaluation = (function (_super) {
    __extends(EditableEvaluation, _super);
    function EditableEvaluation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableEvaluation.prototype.triggerEditMode = function () {
        if (this.props.column.editable && !this.props.inBulkEditMode) {
            App_1.store.risklist.evaluation.setState(this.state.field.data.risk_id, this.state.field.data.matrix_id, this.state.field.data.evaluation_type);
            App_1.store.risklist.evaluation.fetchEvaluation();
            App_1.store.risklist.evaluation.openDialog(this.state.field.data.evaluation_type, this.updateCell.bind(this));
        }
    };
    EditableEvaluation.prototype.updateCell = function (data) {
        var evaluation = data.evaluations[constants_1.EvaluationTypeChoices.asDict()[this.state.field.data.evaluation_type]];
        if (evaluation) {
            var newData = new tablecells_1.TableCellDataEvaluation(this.state.field.data.risk_colors, this.state.field.data.opp_colors, evaluation.cell.color, evaluation.formatted_explicit_var.toString(), this.state.field.data.is_opportunity, this.state.field.data.matrix_id, this.state.field.data.risk_id, evaluation.evaluation_type, this.state.field.data.show_explicit_value);
            var newField = new tablecells_1.EvaluationTableCell(this.state.field.id, newData, this.state.field.display, this.state.field.fieldName);
            this.setState({
                field: newField,
            });
        }
        this.props.refetchTable();
    };
    return EditableEvaluation;
}(BaseEditableCell));
exports.EditableEvaluation = EditableEvaluation;
var EditableBimLocations = (function (_super) {
    __extends(EditableBimLocations, _super);
    function EditableBimLocations() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableBimLocations.prototype.triggerEditMode = function (e) {
        if (this.props.column.editable && !this.props.inBulkEditMode) {
            this.context.openDialog(this.state.field.id);
        }
    };
    EditableBimLocations.contextType = riskbimContext_1.default;
    return EditableBimLocations;
}(BaseEditableCell));
exports.EditableBimLocations = EditableBimLocations;
var EditableReference = (function (_super) {
    __extends(EditableReference, _super);
    function EditableReference() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableReference.prototype.onBlur = function () {
        this.triggerEditMode();
    };
    EditableReference.prototype.onDeleteReferenceClick = function (ref) {
        var self = this;
        fancyConfirm(gettext("Do you really want to delete the reference?"), function () {
            App_1.store.referenceDialog.deleteReference(ref).then(function () {
                notification(gettext("Reference has been successfully deleted"));
                var newList = self.state.field.data.references.filter(function (r) { return r.id != ref.id; });
                var newData = new tablecells_1.TableCellDataReferences(newList, self.state.field.data.originType);
                var newField = new tablecells_1.ReferenceTableCell(self.state.field.id, newData, self.state.field.display, self.state.field.fieldName);
                self.onDataAccepted(newField);
            });
        });
    };
    EditableReference.prototype.renderInput = function () {
        var field = this.state.field;
        return (React.createElement(inputComponents_1.ReferenceListInputCell, { referredObject: field.data.originType, references: field.data.references, onBlur: this.onBlur.bind(this), onEditClick: App_1.store.referenceDialog.openDialog.bind(App_1.store.referenceDialog), onDeleteClick: this.onDeleteReferenceClick.bind(this) }));
    };
    return EditableReference;
}(BaseEditableCell));
exports.EditableReference = EditableReference;
